import SpinStartState from "../../core/src/states/SpinStartState";
import BetModel from "../../core/src/model/BetModel";
import SpinModel from "../../core/src/model/SpinModel";
import UIController from "../../core/src/ui/UIController";
import { UIUpdateEvent } from "../../core/src/ui/UIUpdateEvents";
import CommManager from "../../core/src/controllers/CommManager";
import RequestRegister from "../../core/src/server/requests/RequestRegister";
import App from "../../core/src/App";
import VendorModel from "../model/VendorModel";
import ErrorModel from "../../core/src/model/ErrorModel";
import ViewManager from "../../core/src/utils/ViewManager";
import { DefaultLayers } from "../../core/src/utils/Layers";
import ReelGroup from "../../core/src/views/ReelGroup";
import CommandManager from "../../core/src/commands/CommandManager";
import { Commands } from "../../core/src/commands/CommandEnum";
import JackpotsModel from "../model/JackpotsModel";
import AutoplayModel from "../../core/src/model/AutoplayModel";
import FConnector from "../server/FConnector";
import { IRoundState, PlayResponse } from "../server/FTypes";
import DebugModel from "../../core/src/model/DebugModel";
import { VendorCommandsEnum } from "../commands/VendorCommandsEnum";
import GameModel from "../../core/src/model/GameModel";
export default class VendorSpinStartState extends SpinStartState {
    protected _canExit: boolean;

    startSpin() {
        if (!GameModel.isReplay || VendorModel.freeGames.length > 0) {
            this._canExit = false;

            const scene = ViewManager.getLayer(
                DefaultLayers.Reels
            ).getCurrentScene();
            const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
            reelGroup.disableSwipeSpin();

            super.startSpin();
        }
    }

    public async sendRequest() {
        BetModel.betTime = Date.now();
        if (!SpinModel.isInFreespins() && !SpinModel.isInRespins()) {
            if (
                JackpotsModel.jackpotsAvailable &&
                JackpotsModel.playForJackpot
            ) {
                BetModel.subtractBet(
                    BetModel.totalBet + JackpotsModel.jackpotFee
                );
            } else {
                BetModel.subtractBet(BetModel.totalBet);
            }
            UIController.updateFields(UIUpdateEvent.Balance);
            SpinModel.spinFinished = false;
            App.timeline.call(
                this.playRound,
                [],
                this,
                App.timeline.time + 0.5
            );
        } else {
            let restoreReplayGames = VendorModel.freeGames;
            if (GameModel.isReplay) {
            } else if (
                VendorModel.nextAction != "skip_complete" &&
                !restoreReplayGames
            ) {
                const newState = await FConnector.play(VendorModel.nextAction);
                VendorModel.update(newState);
            } else if (restoreReplayGames.length >= 0) {
                VendorModel.freeGames.shift();
                if (restoreReplayGames.length === 0) {
                    const newState = await FConnector.play(
                        VendorModel.nextAction
                    );
                    VendorModel.update(newState);
                    VendorModel.freeGames = undefined;
                }
            }

            this.exit();
        }
    }

    public async playRound(free = false) {
        let debugData = DebugModel.debugData;
        DebugModel.cleanUp();
        if (BetModel.coinSize > BetModel.balance) {
            ErrorModel.errorCode = 57;
            this.exit();
        } else {
            let tempBet = 0;
            if (BetModel.coinSize === BetModel.balance) {
                tempBet = BetModel.coinSize;
                if (!SpinModel.isInFreespins() && !SpinModel.isInRespins()) {
                    if (
                        JackpotsModel.jackpotsAvailable &&
                        JackpotsModel.playForJackpot
                    ) {
                        BetModel.subtractBet(
                            BetModel.totalBet + JackpotsModel.jackpotFee
                        );
                    } else {
                        BetModel.subtractBet(BetModel.totalBet);
                    }
                }
            }
            const spinResult = await FConnector.play(
                "main",
                BetModel.coinSize === BetModel.balance ? tempBet : BetModel.coinSize,
                {},
                debugData?.feature?.params || debugData?.params || undefined
            );
            this.onBetCompleted(spinResult);
        }
    }

    protected onBetCompleted(data?: PlayResponse<unknown, IRoundState>) {
        this._canExit = true;
        ErrorModel.update(data);
        BetModel.update(data);
        VendorModel.update(data);
        CommandManager.execute(Commands.UPDATE_BALANCE);

        SpinModel.update(data);
        // PromotionalFreeGamesModel.update(data);

        this.exit();
    }

    public exit() {
        if (AutoplayModel.isAutoSpinActive()) {
            CommandManager.execute(Commands.DECREMENT_AUTOPLAY);
        }
        super.exit();
    }

    public canExit(): boolean {
        return this._canExit;
    }
}
